export interface CurrentUser {
  id: string
  login: string
  personneId: string
  roles: string[]
  modules: string[]
  /** `null` = accès illimité (au moins une attribution de rôle sans école précise). */
  ecoleIds: string[] | null
}

/** Utilisateur connecté (`null` tant qu'on n'est pas authentifié). Le jeton lui-même reste dans un cookie HttpOnly, invisible en JS. */
export function useCurrentUser() {
  return useState<CurrentUser | null>('auth-user', () => null)
}

export async function login(loginValue: string, password: string): Promise<void> {
  const user = await $fetch<CurrentUser>('/api/auth/login', {
    method: 'POST',
    body: { login: loginValue, password },
  })
  useCurrentUser().value = user
  await loadDb()
}

export async function logout(): Promise<void> {
  try {
    await $fetch('/api/auth/logout', { method: 'POST' })
  }
  finally {
    useCurrentUser().value = null
    await navigateTo('/login')
  }
}

/** Réhydrate l'utilisateur courant depuis le cookie au démarrage de l'application. Ne jette jamais : `null` si pas connecté. */
export async function fetchMe(): Promise<CurrentUser | null> {
  try {
    const user = await $fetch<CurrentUser>('/api/auth/me')
    useCurrentUser().value = user
    return user
  }
  catch (e) {
    console.error('[Registre] fetchMe:', e)
    useCurrentUser().value = null
    return null
  }
}

/** Session expirée en cours d'utilisation (jeton périmé) : déconnecte et renvoie vers /login. Ne fait rien pour les autres erreurs. */
export async function handleAuthError(error: unknown): Promise<void> {
  const status = (error as { response?: { status?: number }, statusCode?: number })?.response?.status
    ?? (error as { statusCode?: number })?.statusCode
  if (status === 401) {
    useCurrentUser().value = null
    await navigateTo('/login')
  }
}
